import { createFileRoute, Outlet } from '@tanstack/react-router';
import { NotAuthorized } from '@/lib/acl';
import { useCrmAccess } from '@/lib/crm/use-crm-access';

/**
 * The Agency CRM tool (ENT-565). Every `/crm/*` page renders through this gate: the tenant must hold
 * the `crm_core` entitlement and the caller at least one CRM entry key. Each page then checks its
 * own key (`withPermission` in its lazy route file), and each control inside a page its own.
 * The CRM's sidebar is chosen by `Sidebar` from the path, so the layout itself draws no chrome.
 */
export const Route = createFileRoute('/crm')({
  component: CrmLayout,
});

function CrmLayout() {
  const { isLoading, canOpenCrm } = useCrmAccess();
  if (isLoading) return null;
  if (!canOpenCrm) return <NotAuthorized resourceLabel="CRM" />;
  return <Outlet />;
}
